import { useEffect } from "react";

/**
 * Broadcast routes: noindex + no-referrer meta, and a transparent document
 * background so OBS "transparent" really is transparent. Everything is
 * reverted on unmount. `lockScroll` (body overflow hidden) is separate from the
 * transparent background: only the OBS broadcast page locks scroll, the control
 * page must scroll on desktop.
 */
export function useBroadcastDocument(
  transparentBody = true,
  lockScroll = transparentBody,
) {
  useEffect(() => {
    const added: HTMLMetaElement[] = [];
    const addMeta = (name: string, content: string) => {
      const m = document.createElement("meta");
      m.name = name;
      m.content = content;
      document.head.appendChild(m);
      added.push(m);
    };
    addMeta("robots", "noindex, nofollow");
    addMeta("referrer", "no-referrer");

    const html = document.documentElement;
    const body = document.body;
    const prev = {
      htmlBg: html.style.background,
      bodyBg: body.style.background,
      overflow: body.style.overflow,
    };
    if (transparentBody) {
      html.style.background = "transparent";
      body.style.background = "transparent";
    }
    if (lockScroll) body.style.overflow = "hidden";
    return () => {
      added.forEach((m) => m.remove());
      html.style.background = prev.htmlBg;
      body.style.background = prev.bodyBg;
      body.style.overflow = prev.overflow;
    };
  }, [transparentBody, lockScroll]);
}
